// extracted by mini-css-extract-plugin
module.exports = {"scrollBtn":"scroll-btn_scrollBtn__AErV9","btn":"scroll-btn_btn__XMzup"};